import { useMemo } from "react";
import { selectors, useAppSelector } from "store";
import { isCupTechnologyFeatureAvailable } from "utility/feature-availability";
/* The "no technology" option leads, then the sense valves, then the
 * restrictors, so each type is listed as one group. */
var typeOrder = [
    "None",
    "Sense",
    "Restrict",
];
export var useCupTechnologyOptions = function (nodeIds) {
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var currentlySelectedCupTechnology = useAppSelector(selectors.selectSelectedCupTechnologies(nodeIds));
    var cupTechnologyOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupTechnologyComponents))
            return [];
        /* Array.prototype.sort is stable, so each type keeps Tacton's order. */
        return Object.values(systemDataDefineParameters.cupTechnologyComponents).sort(function (a, b) { return typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type); });
    }, [systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.cupTechnologyComponents]);
    var selectedCupTechnologyOptions = useMemo(function () {
        return cupTechnologyOptions.filter(function (option) {
            return option.value &&
                currentlySelectedCupTechnology
                    .map(function (tech) { return tech === null || tech === void 0 ? void 0 : tech.value; })
                    .includes(option.value);
        });
    }, [cupTechnologyOptions, currentlySelectedCupTechnology]);
    if (!isCupTechnologyFeatureAvailable()) {
        return {
            cupTechnologyOptions: [],
            selectedCupTechnologyOptions: [],
        };
    }
    return { cupTechnologyOptions: cupTechnologyOptions, selectedCupTechnologyOptions: selectedCupTechnologyOptions };
};
